export default __webpack_public_path__ + "static/media/afterArrow.56002e54.svg";